<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-12 col-lg-12">
                                                <div class="row">

                                                    <div class="col-xl-8 col-xs-12 col-lg-6 col-md-8">
                                                        <div class="submit-field">
                                                            <h5>Título</h5>
                                                            <input type="text" class="with-border" placeholder="Título da notificação" v-model="form.titulo">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-12"></div>

                                                    <div class="col-xl-6 col-xs-12 col-lg-6 col-md-8">
                                                        <div class="submit-field">
                                                            <h5>Mensagem</h5>
                                                            <textarea class="with-border" placeholder="Escreva a mensagem.." v-model="form.texto"></textarea>
                                                        </div>
                                                    </div>                                                    
                                                    <div class="col-xl-12"></div>

                                                    <div class="col-xl-12 col-xs-12 col-md-12 col-lg-12">
                                                        <div class="submit-field">
                                                            <h5>Destinatário(s)</h5>
                                                            <select class="selectpicker" v-model="form.destinatarios" data-live-search="true" multiple="" show-tick="true" data-allow-clear="false" data-size="5" name="destinatarios" title="Selecione aqui..">
                                                                <option value="*">Todos</option>
                                                                <option v-for="item in usuarios.itens" :value="item.cod">{{item.nome}}</option>
                                                            </select>   
                                                        </div>
                                                    </div>      

                                                    <div class="col-xl-12 col-md-12 col-lg-12 margin-top-10">
                                                        <div class="hidden-lg hidden-xl hidden-md margin-top-10"></div>
                                                        <div class="submit-field margin-bottom-0">
                                                            <div class="checkbox">
                                                                <input type="checkbox" id="recorrente" v-model="form.recorrente" true-value="1" false-value="0">
                                                                <label for="recorrente" style="font-size: 18px;"><span class="checkbox-icon"></span> Envio recorrente</label>
                                                            </div>
                                                        </div>
                                                    </div>                                
                                                    <div class="col-xl-2 col-lg-3 col-xs-8 col-md-7" v-if="form.recorrente == 1">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>Qual o dia?</h5>
                                                        </div>
                                                        <input type="date" class="with-border margin-bottom-5" data-placeholder="___ /____ /_____" v-model="form.data" required="">
                                                        <!-- <input type="number" class="with-border margin-bottom-5" data-placeholder="" placeholder="Dia" v-model="form.dia" required=""> -->
                                                        <small class="help">Será enviado todos os meses no dia acima.</small>
                                                    </div>

                                                    <div class="col-xl-2 col-xs-4 col-md-5" v-if="form.recorrente == 1">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>Hora</h5>
                                                        </div>
                                                        <input type="time" class="with-border" data-placeholder="__ : __" v-model="form.hora" required="">
                                                    </div>   

                                                    <div class="col-xl-12 col-md-12 col-lg-12">
                                                        <div class="submit-field margin-bottom-0 margin-top-15">
                                                            <div class="checkbox">
                                                                <input type="checkbox" id="fixo" v-model="form.fixo" true-value="1" false-value="0">
                                                                <label for="fixo" style="font-size: 18px;"><span class="checkbox-icon"></span> Lembrete fixo na tela inicial</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-12 col-md-12 col-lg-12">
                                                        <div class="submit-field margin-bottom-0 margin-top-15">
                                                            <div class="checkbox">
                                                                <input type="checkbox" id="confirmacao" v-model="form.confirmacao" true-value="1" false-value="0">
                                                                <label for="confirmacao" style="font-size: 18px;"><span class="checkbox-icon"></span> Lembrete com confirmação de leitura</label>
                                                            </div>
                                                        </div>
                                                    </div>                                                    

                                                    <div class="col-xl-12 margin-bottom-20 margin-top-20">
                                                        <button type="submit" class="button big green block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                            <i class="material-icons">save</i>
                                                            {{ form.cod ? 'Salvar lembrete' : 'Cadastrar lembrete' }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'GerenciarNotificacoes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "estoque":              {
                "itens":            []
            },  
            "usuarios":              {
                "itens":            []
            },                              
            "form": {
                "tipo":             "lembrete",
                "titulo":           "",
                "mensagem":         "",
                "destinatarios":    [],
                "fixo":             0,
                "recorrente":       0,
                "hora":             "",
                "dia":              null,
                "data":             null
            }            
        }
    },
    methods: {      
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a   = "post";
            if (self.form.cod) {
                a   = "put";
            }
            axios[a]("api/notificacoes.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },  
        getUsuarios: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "usuarios",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "admin,prestador,gerencial"
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUsuarios() result", response.data);
                    self.usuarios.itens  = response.data.result.itens;
                    self.$forceUpdate();
                    resolve(response.data.result);
                    setTimeout(function() {
                        $(".selectpicker[name='destinatarios']").selectpicker()                    
                    }, 100);                    

                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },                  
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/notificacoes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        init: function() {
            var self = this;

            if (self.$route.name == "EditarNotificacoes") {
                if (!self.$route.query.c) {
                    self.$root.back();
                    return false;
                }
                self.form.cod = self.$route.query.c;
                // self.get();
                Promise.all([
                    self.get(),
                    self.getUsuarios(), 
                ]).then(function() {
                    loading.hide();
                }).catch(function(error) {
                    loading.hide();
                });            
            } else {
                Promise.all([
                    self.getUsuarios(), 
                ]).then(function() {
                    loading.hide();
                }).catch(function(error) {
                    loading.hide();
                });
            }            

        }      
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }  

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .dashboard-box h3 {
        border-bottom: 1px solid #ddd;
        padding-bottom: 8px;
        margin-bottom: 25px;
        color: #000;
    }

    .dashboard-box h3 i {
        color: #FF4000;
    }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarNotificacoes.vue